/* FitLibrary scroll motion — hero departure + section reveals.
   No libraries. Transform/opacity only. Passive listeners, rAF-throttled. */
(function () {
  "use strict";

  var REDUCE = window.matchMedia("(prefers-reduced-motion: reduce)");

  /* ---------------- a) HERO DEPARTURE ---------------- */
  function initHero(root) {
    var hero = (root || document).querySelector("[data-hero]");
    var scene = hero && hero.querySelector("[data-hero-scene]");
    var copy = hero && hero.querySelector(".chero__copy");
    if (!hero || !scene || hero.dataset.motionBound === "1") return;
    hero.dataset.motionBound = "1";

    var narrow = window.matchMedia("(max-width: 900px)");
    var ticking = false, cleared = false, last = -1;

    function clear() {
      hero.style.removeProperty("--hero-wy");
      hero.style.removeProperty("--hero-depth");
      hero.style.removeProperty("--hero-cy");
      hero.style.removeProperty("--hero-copy-o");
    }

    function update() {
      ticking = false;
      if (REDUCE.matches) { if (!cleared) { cleared = true; clear(); } return; }
      cleared = false;

      var r = hero.getBoundingClientRect();
      if (!r.height) return;
      var p = r.top > 0 ? 0 : Math.min(1, -r.top / r.height);
      if (Math.abs(p - last) < 0.002) return;
      last = p;

      var amp = parseFloat(getComputedStyle(hero).getPropertyValue("--hero-scroll-amp"));
      if (!(amp >= 0)) amp = 1;
      var e = p * p * (3 - 2 * p); /* smoothstep */
      var mobile = narrow.matches;

      hero.style.setProperty("--hero-wy", (e * (mobile ? 34 : 86) * amp).toFixed(2) + "px");
      hero.style.setProperty("--hero-depth", (e * (mobile ? 26 : 64) * amp).toFixed(2) + "px");
      if (copy && !mobile) {
        hero.style.setProperty("--hero-cy", (e * -42 * amp).toFixed(2) + "px");
        hero.style.setProperty("--hero-copy-o", (1 - Math.min(0.55, e * 0.55 * amp)).toFixed(3));
      } else {
        hero.style.removeProperty("--hero-cy");
        hero.style.removeProperty("--hero-copy-o");
      }
    }

    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    var listening = false;
    function bind(on) {
      if (on === listening) return;
      listening = on;
      if (on) window.addEventListener("scroll", queue, { passive: true });
      else window.removeEventListener("scroll", queue);
    }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        bind(entries[0].isIntersecting);
        queue();
      }, { rootMargin: "200px 0px 200px 0px" }).observe(hero);
    } else {
      bind(true);
    }

    window.addEventListener("resize", function () { last = -1; queue(); }, { passive: true });
    if (REDUCE.addEventListener) REDUCE.addEventListener("change", function () { last = -1; queue(); });
    queue();
  }

  /* ---------------- b) SECTION REVEALS ---------------- */
  var io = null;

  function release(el) {
    el.removeAttribute("data-reveal");
    el.removeAttribute("data-reveal-group");
    el.classList.remove("is-in-view");
  }

  function initReveals(root) {
    var nodes = Array.prototype.slice.call(
      (root || document).querySelectorAll("[data-reveal], [data-reveal-group]")
    );
    if (!nodes.length) return;

    if (REDUCE.matches || !("IntersectionObserver" in window)) {
      nodes.forEach(release);
      return;
    }

    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          entry.target.classList.add("is-in-view");
          /* Longest transition + longest stagger, then hand the element back so
             its authored hover transition takes over again. */
          setTimeout(function () { release(entry.target); }, 1250);
        });
      }, { threshold: 0.08, rootMargin: "0px 0px -6% 0px" });
    }

    nodes.forEach(function (el) { io.observe(el); });
  }

  function initAll(root) { initHero(root); initReveals(root); }

  initAll(document);

  /* Theme Editor re-renders sections without reloading the page */
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:unload", function (e) {
    var hero = e.target.querySelector && e.target.querySelector("[data-hero]");
    if (hero) hero.dataset.motionBound = "";
  });
})();
